export default __webpack_public_path__ + "static/media/MohammedAli_Resume.a6d4a5bf.pdf";